<template>
  <div class="msg">{{ messageText }}</div>
</template>

<script>
export default {
  name: 'MsgEntityCollectionEmpty',
  props: {
    message: {
      type: String,
      default: '',
    },
    name: {
      type: String,
      default: 'data',
    },
  },
  computed: {
    messageText() {
      return this.message
        ? this.message
        : `There are no ${this.name} that fit your criteria, please adjust your filters and try again.`;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/assets/scss/variables-site/variables' as vars;

.msg {
  color: vars.$c-dark-gray;
  font-size: 16px;
  font-weight: 400;

  @media (min-width: vars.$tablet-break-point) {
    font-size: 24px;
  }
}
</style>
